import { FC, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { TFolder, useFolder } from '@modules/items';
import { StatusLabel } from '@shared/components';

import { TSingleSubmissionData } from '../types/submissions.types';
import { useSubmission } from '../api';
import SingleSubmissionContent from '../components/single/SingleSubmissionContent';
import { useDocumentTitle } from '@shared/hooks';

const SingleSubmission: FC = () => {
  const { productId, submissionId } = useParams();

  const { error: folderError, data: folder } = useFolder(productId);
  const { error: submissionError, data: submissionData } = useSubmission(submissionId as string);

  const error = folderError || submissionError;

  const data: TSingleSubmissionData | null = useMemo(() => {
    if (folder && submissionData) {
      return {
        folder: folder as TFolder,
        submissionData: submissionData,
      };
    }
    return null;
  }, [folder, submissionData]);

  useDocumentTitle(submissionData ? submissionData.submission.title : 'Submission');

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading submission details..."
      error={error}
      errorMessage="Loading submission details failed!"
      render={(resolvedData) => <SingleSubmissionContent data={resolvedData} />}
    />
  );
};

export default SingleSubmission;
